import type { IconDef } from '../types';

export const tickWithContainer: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M12 0C18.6218 0 24 5.37818 24 12C24 18.6218 18.6218 24 12 24C5.37818 24 0 18.6218 0 12C1.93648e-07 5.37818 5.37818 1.93642e-07 12 0ZM18.9717 8.17969C18.6695 7.84415 18.1522 7.81725 17.8164 8.11914L10.4834 14.7178L7.0918 11.6787C6.75535 11.3772 6.23811 11.4059 5.93652 11.7422C5.63525 12.0786 5.66294 12.5959 5.99902 12.8975L9.93848 16.4277C10.2496 16.7065 10.7216 16.706 11.0322 16.4268L18.9111 9.33594C19.247 9.03366 19.2739 8.51556 18.9717 8.17969Z',
    },
  ],
};
